import { useCarTransportTruckGet } from 'api/car-transport-truck/car-transport-truck';
import { useEffect } from 'react';
import { BasicFormState } from 'hooks/useForm';
import useGlobalSettings from 'hooks/useGlobalSettings';
import { GlobalSettingEnum } from 'api/model';
import { useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignment } from 'api/assignment/assignment';
import { AssignmentField } from './types';

export default function useCarTransportTruckSlots(
  assignmentId: number,
  state: BasicFormState<AssignmentField>,
  onChange: (
    assignmentId: number,
    field: AssignmentField,
    value: string
  ) => void,
  carTransportTruckID?: number
) {
  const { parsedData, loaded: loadedGlobalSettings } = useGlobalSettings();

  const getCarTransportTruckCall = useCarTransportTruckGet(
    {
      id: carTransportTruckID,
    },
    {
      query: {
        enabled: !!carTransportTruckID && assignmentId !== -1,
      },
    }
  );

  const getAssignedCarsCall =
    useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignment(
      {
        assignmentId,
      },
      {
        query: {
          enabled: !!carTransportTruckID && assignmentId !== -1,
        },
      }
    );

  // set the default on / off loading times when we get the car transport truck (if any) is loaded, and the values have not already been set
  useEffect(() => {
    if (
      getCarTransportTruckCall.isSuccess &&
      getCarTransportTruckCall.data &&
      getAssignedCarsCall.isSuccess &&
      getAssignedCarsCall.data &&
      getAssignedCarsCall.data.length === 0
      //   &&
      //   state[AssignmentField.estimatedLoadingTime] === '' &&
      //   state[AssignmentField.estimatedUnloadingTime] === ''
    ) {
      const maxNumberOfCars =
        getCarTransportTruckCall.data.maxNumberOfCars ?? 0;
      const defaultLoadingTime =
        parsedData[GlobalSettingEnum.CarTransportTruckOnOffLoadingTimePerCar] *
        maxNumberOfCars *
        60 *
        1000; // convert to milliseconds

      onChange(
        assignmentId,
        AssignmentField.estimatedLoadingTime,
        String(defaultLoadingTime)
      );
      onChange(
        assignmentId,
        AssignmentField.estimatedUnloadingTime,
        String(defaultLoadingTime)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getCarTransportTruckCall.data?.maxNumberOfCars,
    loadedGlobalSettings,
    getAssignedCarsCall.data?.length,
  ]);

  return getCarTransportTruckCall.data?.maxNumberOfCars ?? 0;
}
